const resource = '/admin/v1/contacts';

export default $axios => ({
  index(payload) {
    return $axios.post(`${resource}/search`, payload);
  },
  
  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },
});
